/**
 * Visual covers per blog category — elegant editorial gradients + icon
 * No external image deps; consistent on-brand look across the gallery.
 */
export const CATEGORY_COVERS = {
  "Padecimientos": {
    bg: "linear-gradient(135deg, #1a2421 0%, #2c4a3b 55%, #bc6c25 130%)",
    accent: "#bc6c25",
    icon: "🌿",
    label: "Sanar desde la raíz",
  },
  "Mujer +40": {
    bg: "linear-gradient(135deg, #4a2e2a 0%, #bc6c25 60%, #e0a06b 130%)",
    accent: "#fff5e6",
    icon: "✨",
    label: "Bioquímica femenina",
  },
  "Salud cerebral": {
    bg: "linear-gradient(135deg, #2c4a3b 0%, #1a3a4a 60%, #5c8a9a 130%)",
    accent: "#cfe4ec",
    icon: "🧠",
    label: "Función cognitiva",
  },
  "Medicina funcional": {
    bg: "linear-gradient(135deg, #2c4a3b 0%, #6d8a7a 60%, #c4d4cc 130%)",
    accent: "#1a2421",
    icon: "⚕",
    label: "Causa raíz",
  },
  "Producto": {
    bg: "linear-gradient(135deg, #bc6c25 0%, #d4854e 50%, #f0ebe1 120%)",
    accent: "#1a2421",
    icon: "✦",
    label: "Guía de producto",
  },
  "Biohacking": {
    bg: "linear-gradient(135deg, #1a2421 0%, #3d4a45 55%, #8a9a92 130%)",
    accent: "#e0a06b",
    icon: "▲",
    label: "Optimización celular",
  },
  "Energía": {
    bg: "linear-gradient(135deg, #bc6c25 0%, #e0a06b 50%, #f4d8a8 130%)",
    accent: "#1a2421",
    icon: "☀",
    label: "Vitalidad diaria",
  },
  "Ciencia": {
    bg: "linear-gradient(135deg, #1a3a4a 0%, #2c4a3b 60%, #4a5a52 130%)",
    accent: "#cfe4ec",
    icon: "✺",
    label: "Evidencia clínica",
  },
};

const FALLBACK = {
  bg: "linear-gradient(135deg, #1a2421 0%, #2c4a3b 100%)",
  accent: "#bc6c25",
  icon: "✦",
  label: "Eliora Longevity",
};

export function getCover(category) {
  return CATEGORY_COVERS[category] || FALLBACK;
}
